import { YammerState } from '../../state/types';

type GetSearchSessionConversationId = (state: YammerState) => string | undefined;
export const getSearchSessionConversationId: GetSearchSessionConversationId = (state) =>
  state.searchSession.conversationId;

type GetSearchSessionConversationStart = (state: YammerState) => number | undefined;
export const getSearchSessionConversationStart: GetSearchSessionConversationStart = (state) =>
  state.searchSession.conversationStart;

type GetSearchSessionLogicalId = (state: YammerState) => string | undefined;
export const getSearchSessionLogicalId: GetSearchSessionLogicalId = (state) => state.searchSession.logicalId;
